// Vendors
import "./vendor/jquery";
import "./vendor/bootstrap";
import "./vendor/slick";
import "./vendor/gallery-lightbox";
//import "./vendor/gmap3";

//import "./modules/darkmode-handler";

import "./modules/footer";
import "./modules/template-landing";
import "./modules/header";
import "./modules/contact-form";
import "./modules/loan-accordion";
import "./modules/hp-widget-tab";
import "./modules/store-locator";
import "./modules/partner-locator";
import "./modules/card-accordion";
//import "./modules/years-swiper";
import "./modules/customer-area-modal";
import "./modules/modal-search";
import "./modules/modal";
// import "./modules/search-result-card";
import "./modules/countdown";
import "./modules/feedback";
import "./modules/comparative-card";
import "./modules/service-communicate";
import "./modules/ricerca-immobili";
import "./modules/soci-login";
